module.exports = __webpack_public_path__ + "img/fendanyun_01.bab4c7f4.jpg";